<script>
    import wait from '../../libs/wait';
    import { brands } from '../../settings/colors';

    export let click = () => { };
    export let label = 'No Label'
    export let description = 'No description'
    export let count = null
    export let icon = 'fad fa-house'
    export let index = 0
    
    let odd = index % 2 === 1
    let touchstartTriggered = false
    let button = null

    const handleClick = (e) => {
        if (!touchstartTriggered)
            click (e);
    }
    const handleTouchStart = (e) => {
        touchstartTriggered = true;
        if (button)
            button.style.transform = 'scale(0.9)';
    }

    const handleTouchEnd = (e) => {
        if (button)
            button.style.transform = 'scale(1)';
        wait (200).then (click.call (this, e))
    }
</script>

<div bind:this={button} class="section-block" class:odd style="background-color: {brands[index]}" 
    on:touchstart={handleTouchStart} 
    on:touchend={handleTouchEnd} 
    on:click={handleClick}>
    <div class="count">
        {#if (count !== null)}
            {count}
        {:else}
            <i class={icon}></i>
        {/if}
    </div>
    <div class="lbl">{label}</div>
    <!-- <div class="txt">{description}</div> -->
</div>

<style>
    .section-block {
        float: left;
        width: 48%;
        margin-right: 4%;
        margin-bottom: 10px;
        background-color: #0984e3;
        color: #fff;
        text-align: center;
        border-radius: 3px;
        padding-bottom: 15px;
        transition: all 0.15s;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .section-block.odd {
        margin-right: 0;
    }
    .section-block .count {
        font-size: 36px;
        font-weight: 300;
        line-height: 80px;
        color: #fff;
        text-align: center;
    }
    .section-block .lbl {
        font-size: 18px;
        line-height: 21px;
        font-weight: 600;
    }
    .section-block .txt {
        font-size: 13px;
        line-height: 16px;
        color: rgba(255, 255, 255, .8);
    }

    @media(min-width: 700px) {
        .section-block {
            width: 160px;
        }
        .section-block, .section-block.odd {
            margin-right: 10px;
        }
    }
</style>